
const colors = {
  white: "#FFFFFF",
  black: "#010101"
}

export default colors